export const VISUAL_COMMENT_TYPE = {
  text: 1,
  photo: 2,
  audio: 3,
  video: 4,
  document: 5,
} as const;

export const VISUAL_COMMENT_TYPE_SYMBOL = {
  mixed: "...",
  text: "Т",
  photo: "Ф",
  audio: "А",
  video: "В",
  document: "Д",
} as const;

export type TCommentTypeSymbol = (typeof VISUAL_COMMENT_TYPE_SYMBOL)[keyof typeof VISUAL_COMMENT_TYPE_SYMBOL] | null;

interface IVisualCommentCounts {
  textCommentsCount: number;
  photoCommentsCount: number;
  audioCommentsCount: number;
  videoCommentsCount: number;
  documentCommentsCount: number;
}

const VISUAL_FILE_COMMENT_SYMBOLS = [
  { countKey: "photoCommentsCount", symbol: VISUAL_COMMENT_TYPE_SYMBOL.photo },
  { countKey: "audioCommentsCount", symbol: VISUAL_COMMENT_TYPE_SYMBOL.audio },
  { countKey: "videoCommentsCount", symbol: VISUAL_COMMENT_TYPE_SYMBOL.video },
  { countKey: "documentCommentsCount", symbol: VISUAL_COMMENT_TYPE_SYMBOL.document },
] as const;

export const getVisualCommentTypeSymbol = (counts: IVisualCommentCounts): TCommentTypeSymbol => {
  const hasTextComment = counts.textCommentsCount > 0;
  const fileSymbols = VISUAL_FILE_COMMENT_SYMBOLS.filter(item => counts[item.countKey] > 0).map(item => item.symbol);

  if (hasTextComment && fileSymbols.length > 0) {
    return VISUAL_COMMENT_TYPE_SYMBOL.mixed;
  }

  if (hasTextComment) {
    return VISUAL_COMMENT_TYPE_SYMBOL.text;
  }

  if (fileSymbols.length === 1) {
    return fileSymbols[0];
  }

  if (fileSymbols.length > 1) {
    return VISUAL_COMMENT_TYPE_SYMBOL.mixed;
  }

  return null;
};

export const isVisualFileCommentType = (commentType: number): boolean =>
  commentType === VISUAL_COMMENT_TYPE.photo ||
  commentType === VISUAL_COMMENT_TYPE.audio ||
  commentType === VISUAL_COMMENT_TYPE.video ||
  commentType === VISUAL_COMMENT_TYPE.document;

export const getVisualCommentMessageId = (commentType: number): string | null => {
  switch (commentType) {
    case VISUAL_COMMENT_TYPE.photo:
      return "dialogs.photo";
    case VISUAL_COMMENT_TYPE.audio:
      return "dialogs.audio";
    case VISUAL_COMMENT_TYPE.video:
      return "dialogs.video";
    case VISUAL_COMMENT_TYPE.document:
      return "dialogs.document";
    default:
      return null;
  }
};
